export default "__VITE_ASSET__S2V$cqJl__"